// extracted by mini-css-extract-plugin
module.exports = {"getStarted":"getStarted-module--getStarted--2h75L","actionButton":"getStarted-module--actionButton--23ylt"};